<!-- 考试详情 -->
<template>
<div class="cm_examDetail_body">
  <div class="cm_examDetail_container">
    <div class="cm_news_list_title">
      <h3>在线答题</h3>
      <span>您的位置：在线答题</span>
    </div>
    <div class="cm_exam_box" v-if="!examIsShow"> 
      <h3>{{examInfo.EXAMARRANGE_NAME}}</h3>
      <div class="cm_exam_info">
        <span>总分：{{examInfo.EXAMARRANGE_TOTALSCORE}}</span>
        <span>及格线：{{examInfo.EXAMARRANGE_PASSSCORE}}</span>
        <span>考试时间：{{examInfo.EXAMARRANGE_TIME}}</span>
      </div>
      <div class="cm_exam_info_input" >
      <input type="text" placeholder="请输入您的单位和姓名，例如：单位+张三"  v-model="userInfo" />
      <span v-show="showTips">内容不能为空</span>
      </div>
      <button @click="startTest()">开始测试</button>
    </div>
    <div class="cm_exam_detail" v-else>
      <ul>
        <li v-for="(item,index) in dataList" :key="item.id" v-show="activeNum == index">
          <div class="cm_exam_detail_title"><span>{{index+1}}.[{{item.itemtype}}]</span>{{item.title}}</div>
          <div v-if="item.itemtype!='多选题'" >
            <div v-for="child in item.options" :key="child.id" >
            <el-radio v-model="radio[index]" :label="child.enid" class="cm_exam_detal_option" :disabled="resultFlag">{{child.enid}}.{{child.options}}</el-radio>
          </div>
          </div>
          <div v-else>
            <div v-for="(child,checkboxNum) in item.options" :key="child.id">
            <el-checkbox  v-model="dx[checkboxNum]" :label="child.enid" class="cm_exam_detal_option" :disabled="resultFlag">{{child.enid}}.{{child.options}}</el-checkbox>
            <!-- TODO -->
          </div>
          </div>
        </li>
      </ul>
      <div class="cm_exam_button" v-if="!resultFlag">
        <el-button type="primary" round :disabled="activeNum<=0" @click="changeExam(-1)">上一题</el-button>
        <el-button type="primary" round :disabled="activeNum>=dataList.length-1" @click="changeExam(1)">下一题</el-button>
        <el-button type="primary" round @click="submitExam">提交</el-button>
      </div>
      
      <div v-else>
        <div class="cm_exam_result_answer">
          <div class="cm_exam_result_answer_top">
            <span>您的答案：{{radio[activeNum]}}</span>
            <span>正确答案：{{dataList[activeNum].answer}}</span>
          </div>
          <span>解析：{{dataList[activeNum].jiexi}}</span>
        </div>
        <ul class="cm_exam_result">
          <li v-for="item in dataList.length" :key="item" :class="item-1==activeNum?'cm_isActive':wrong.indexOf(item-1)>-1||radio.length<=item-1?'cm_wrong':''"  @click="activeNum = item-1">{{item}}</li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用 
  components: {},
  data() {
    //这里存放数据  
    return {
      paperId:this.$route.params.newsId,
      id:JSON.parse(this.$route.query.ID),
      dataList:[
      
      ],
      examInfo:"",
      examIsShow:false,
      activeNum:0,
      radio:[],
      wrong:[],
      dx:[],
      count:0,
      resultFlag:false,
      userInfo:"",
      showTips:false
    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {

    startTest(){
      if(this.userInfo == "" || this.userInfo==undefined || this.userInfo==null){
        this.showTips = true
        return
      }else{
        this.examIsShow=true
      }

    },
    changeExam(der){
     if(this.dx.length > 0){
       var dxAnswer = []
       for(var i = 0;i<this.dx.length;i++){
         if(this.dx[i]){
           var answer = i==0?"A":i==1?"B":i==2?"C":i==3?"D":i==4?"E":i==5?"F":""
           dxAnswer.push(answer)
         }
       }
       this.radio[this.activeNum] = dxAnswer
     }
     this.dx = []
     this.activeNum = this.activeNum + der
    },
    submitExam(){
      let submitFlag = false;
      let noticeString = "是否提交试卷?"
      if(this.radio.length<this.dataList.length){
        noticeString = '您还有题目未完成, 是否继续提交?'
      }
      for(let i =0; i<this.radio.length;i++){
        if( this.radio[i]=="" || this.radio[i]==undefined || this.radio[i]==null){
          noticeString = '您还有题目未完成, 是否继续提交?'
      }
      
        this.$confirm(noticeString, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          if(this.dx.length > 0){
       var dxAnswer = []
       for(var i = 0;i<this.dx.length;i++){
         if(this.dx[i]){
           var answer = i==0?"A":i==1?"B":i==2?"C":i==3?"D":i==4?"E":i==5?"F":""
           dxAnswer.push(answer)
         }
       }
      this.radio[this.activeNum] = dxAnswer

     }
     this.dx = []
     //console.log(this.radio)
          this.submitAnswer()
          for(let i =0; i<this.radio.length;i++){

            if(this.dataList[i].answer == this.radio[i]){
              this.count +=  parseInt(this.dataList[i].score)
            }else if(this.radio[i] instanceof Array&&this.radio[i].length>0){
              let dxResult = this.dataList[i].answer.split(",")
              if(this.radio[i].toString()==dxResult.toString()){
                this.count +=  parseInt(this.dataList[i].score)
              }else{
                this.wrong.push(i)
              }
            }else{
              this.wrong.push(i)
            }
            
          }
          let answerNotice = ""
          if(this.count>=this.examInfo.EXAMARRANGE_PASSSCOR){
            answerNotice = "您的成绩未合格,"
          }else{
            answerNotice = "您已达标,"
          }
           this.$confirm(answerNotice+'您的总成绩为：'+ this.count, '成绩', {
          confirmButtonText: '查看错题',
          cancelButtonText: '退出',
          type: 'warning'
        }).then(() => {
          this.resultFlag = true
          this.activeNum = 0
        }).catch(() => {
            this.$router.push({path:'/exam'})
        }); 
        
        }).catch(() => {
                  
        });
      }
      
    },
    submitAnswer(){
      for(let i=0;i<this.dataList.length;i++){
        if(this.radio[i]!=""&&this.radio[i]!=undefined&&this.radio!=null){
          if(this.radio[i] instanceof  Array){
            this.radio[i] = this.radio[i].toString()
          }
          this.dataList[i].userAnswer = this.radio[i]
        }else{
          this.dataList[i].userAnswer = ""
        }
        this.dataList[i].angID = this.dataList[i].id;
        this.dataList[i].panswer = this.dataList[i].answer;
        this.dataList[i].wanswer = this.dataList[i].userAnswer;
        this.dataList[i].answerid = this.dataList[i].id;
      }
    this.$http({
      url: this.$http.adornUrl("requestMainMobile/itemBankService/pubSubmitPaper"),
      method: 'post',
      data: {
        EXAM_USERNAME:this.userInfo,
        EXAMPAPERID:this.paperId,
        EXAMID:this.id,
        itemsJsonData:JSON.stringify(this.dataList),
      }
    }).then(({data})=>{
      debugger
    })
    },
    httpPost() {
      this.$http({
        url: this.$http.adornUrl("requestMainMobile/itemBankService/pubGoExamJs"),
        method: 'post',
        data: {EXAMPAPERID:this.paperId,
        examid:this.id}
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.LIST
          this.examInfo = data.data.Exam
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.httpPost()
  },
};
</script>
<style>
  .cm_exam_info_input{
    width: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
.cm_exam_info_input>input{
  width: 350px;
  height: 50px;
  padding:10px;
  border: 1px solid #a4a4a4;
  border-radius: 3px;
}
  .cm_exam_info_input>span{
    color: red;
  }
.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #4379D3!important;
    border-color: #4379D3!important;
}
.el-checkbox__input.is-checked + .el-checkbox__label{
  color:#4379D3!important;
}
.cm_exam_result_answer_top{
  width: 100%;
}
.cm_exam_result_answer_top>span{
  margin-right: 40px;
}

.cm_exam_result_answer{
  margin:20px 0;
}
.cm_examDetail_body{
  display: flex;
  justify-content: center;
}
.cm_wrong{
  background: #B0171F;
  color:#fff;
}
.cm_exam_result{
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}
.cm_isActive{
  background: #4379D3;
  color:#fff;
}
.cm_exam_result>li{
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #4379D3;
  margin-right: 10px;
  cursor: pointer;
}
.el-button.is-round {
    width: 125px;
}
.cm_exam_button{
  margin-top:40px;
  margin-bottom:40px;
}
.el-button--primary:hover {
    background: #4379D3 !important;
    border-color: #4379D3 !important;
    opacity: 0.5;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:hover, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:active {
    background-color: #4379D3 !important;
    border-color: #4379D3 !important;
    opacity: 0.5;
}
.el-button--primary {
    color: #FFFFFF;
    background-color: #4379D3 !important;
    border-color: #4379D3 !important;
}
.el-radio__input.is-checked + .el-radio__label{
  color: #4379D3 !important;
}
.el-radio__input.is-checked .el-radio__inner {
    border-color: #4379D3 !important;
    background: #4379D3 !important;
}
.cm_exam_detal_option{
  padding-top:50px;
}
.cm_exam_detail_title{
  width: 100%;
background: #F2F2F2;
border-radius: 3px;
line-height: 30px;

}
.cm_exam_detail_title>span{
  display:inline-block;
font-weight: 400;
color: #4379D3;
}
.cm_examDetail_container {
  margin-top: 20px;
  width: 1200px;
  background: #fff;
  padding: 0 30px;
  padding-bottom: 20px;
}
.cm_news_list_title {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379d3;
}
.cm_news_list_title > h3 {
  font-size: 20px;
  font-weight: 500;
  color: #4379d3;
}
.cm_news_list_title > span {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_exam_detail{
  margin: 20px 0 ;
}
.cm_exam_box{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  height: 500px;
}
.cm_exam_box>h3{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 30px;
  color: #4379D3;
}
.cm_exam_box>button{
  width: 139px;
  height: 44px;
  background: #4379D3;
  border-radius: 25px;
  cursor: pointer;
  border: none;
  color: #FFF;
}
.cm_exam_box>button:hover,.cm_exam_box>button:focus{
opacity: 0.5;
}
.cm_exam_info{
  width: 100%;
  display:flex;
  flex-wrap:wrap;
  height: 100px;
}
.cm_exam_info>span{
  flex:1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>